import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import UserDataProvider from "./context/User";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename="/lwbl">
    <UserDataProvider>
      <App />
    </UserDataProvider>
  </BrowserRouter>
);

reportWebVitals();
